import { httpClient } from './http-client';
import { API_ENDPOINTS } from '../config/api';

/** Полный DTO региона (для старого /hierarchy) */
export interface RegionItem {
  id: number;
  nameKz: string;
  nameRu: string;
  nameEn: string;
  parentId: number | null;
  regionType: number;
  regionTypeName: string;
  children?: RegionItem[] | null;
}

/** Лёгкий DTO для lazy-tree (без children, с childCount) */
export interface RegionNodeDto {
  id: number;
  nameKz: string;
  nameRu: string;
  nameEn: string;
  parentId: number | null;
  regionType: number;
  regionTypeName: string;
  childCount: number;
}

/** Запрос на создание/обновление региона */
export interface RegionFormData {
  nameKz: string;
  nameRu: string;
  nameEn: string;
  parentId: number | null;
  regionType: number;
}

export const regionService = {
  /** [DEPRECATED] Полная иерархия — тянет всё дерево */
  getHierarchy(): Promise<{ success: boolean; data?: RegionItem[]; message?: string }> {
    return httpClient.get<RegionItem[]>(API_ENDPOINTS.REGION.HIERARCHY);
  },

  /** Прямые потомки региона (или корневые, если parentId = undefined) */
  getChildren(parentId?: number | null): Promise<{ success: boolean; data?: RegionNodeDto[]; message?: string }> {
    const params = parentId != null ? `?parentId=${parentId}` : '';
    return httpClient.get<RegionNodeDto[]>(API_ENDPOINTS.REGION.CHILDREN + params);
  },

  /** Поиск по имени (мин 2 символа) */
  search(q: string, limit = 30): Promise<{ success: boolean; data?: RegionNodeDto[]; message?: string }> {
    return httpClient.get<RegionNodeDto[]>(
      `${API_ENDPOINTS.REGION.SEARCH}?q=${encodeURIComponent(q)}&limit=${limit}`
    );
  },

  /** Создать регион (требует Moderator+) */
  create(data: RegionFormData): Promise<{ success: boolean; data?: RegionNodeDto; message?: string }> {
    return httpClient.post<RegionNodeDto>(API_ENDPOINTS.REGION.LIST, data);
  },

  /** Обновить регион (требует Moderator+) */
  update(id: number, data: RegionFormData): Promise<{ success: boolean; data?: RegionNodeDto; message?: string }> {
    return httpClient.put<RegionNodeDto>(`${API_ENDPOINTS.REGION.LIST}/${id}`, data);
  },

  /** Удалить регион (требует Moderator+) */
  delete(id: number): Promise<{ success: boolean; message?: string }> {
    return httpClient.delete(`${API_ENDPOINTS.REGION.LIST}/${id}`);
  },
};
